<script setup lang="ts">
import EntitySidebarField from '@/modules/Project/Entity/EntitySidebarField.vue'
import EntitySidebarFieldContainer from '@/modules/Project/Entity/EntitySidebarFieldContainer.vue'
import SidebarSelectField from '@/modules/Project/Fields/SidebarSelectField.vue'
import type {
  FieldEmits,
  FieldProps,
  GroundedFieldEmits,
} from '@/modules/Project/Fields/field-types'

defineProps<FieldProps<'hub_select'>>()
defineEmits<FieldEmits<'hub_select'> & GroundedFieldEmits>()
</script>

<template>
  <EntitySidebarField
    :field="field"
    :property="property"
  >
    <template #field="{ labelId }">
      <EntitySidebarFieldContainer class="pl-2">
        <SidebarSelectField
          :property="property"
          :field="field"
          :aria-labelledby="labelId"
          @submit="$emit('submit', $event)"
          @focus="$emit('focus', $event)"
          @blur="$emit('blur', $event)"
          @show-source="$emit('show-source', $event)"
        />
      </EntitySidebarFieldContainer>
    </template>
  </EntitySidebarField>
</template>
